import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetFulfillmentProductGroupsByOrderIdApi } from '@/clients/fulfillment/fulfillment.ts';

export function getFulfillmentProductGroupsByOrderIdQueryKey(orderId: string) {
    return ['fulfillment-product-groups-by-order-id', orderId];
}

export const useGetFulfillmentProductGroupByOrderId = (orderId: string) => {
    const { getFulfillmentProductGroupsByOrderId } = useGetFulfillmentProductGroupsByOrderIdApi();
    return useSuspenseQuery({
        queryKey: getFulfillmentProductGroupsByOrderIdQueryKey(orderId),
        queryFn: () => getFulfillmentProductGroupsByOrderId(orderId),
        refetchOnWindowFocus: false,
        select: data => data[0],
    });
};
